function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "BG",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67647",
  "data-name": "Group 67647",
  transform: "translate(1.234 1.234)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52241",
  "data-name": "Path 52241",
  d: "M16.208,20.514l-1.75-5.589a.711.711,0,0,1,.979-.856L20.656,16.5a.711.711,0,0,1-.153,1.339l-2.149.455-.8,2.241A.711.711,0,0,1,16.208,20.514Z",
  transform: "translate(-1.533 -1.481)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52242",
  "data-name": "Path 52242",
  d: "M19.136,10.1H15.479A2.479,2.479,0,0,1,13,7.622h0a2.48,2.48,0,0,1,.726-1.753l2.151-2.151",
  transform: "translate(-1.358 -0.212)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52243",
  "data-name": "Path 52243",
  d: "M4.438,16.273,6,13.937a1.52,1.52,0,0,1,1.265-.678h0a1.52,1.52,0,0,0,1.36-.841l.117-.233a1.521,1.521,0,0,0,0-1.36L7.744,8.841A1.519,1.519,0,0,0,6.384,8H2.52",
  transform: "translate(-0.064 -0.741)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52244",
  "data-name": "Path 52244",
  d: "M9.889,2a7.889,7.889,0,1,0,0,15.778",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52245",
  "data-name": "Path 52245",
  d: "M18.889,9.889A7.876,7.876,0,0,0,11,2",
  transform: "translate(-1.111)",
  fill: "none",
  stroke: "#7e84a3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

function SvgDomainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "domainIcon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainIcon);
export default __webpack_public_path__ + "static/media/domainIcon.859e795a.svg";
export { ForwardRef as ReactComponent };